/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Distribución y eficacia por valor de una categoría.
 */
export interface CategoryDistributionDTO { 
    value: string;
    total: number;
    goals: number;
    percentage: number;
}

